
// import VuePdfApp from "vue-pdf-app";

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import VueDocPreview from 'vue-doc-preview'

import "vue-pdf-app/dist/icons/main.css";


export default {

  props: ["pdfFile","lampiran_type"],
  components: {
      // VuePdfApp,
      VuePdfEmbed,
      VueDocPreview,
  },
}
